import Layout from '../modules/Layout';
import BuyGiftCards from '../modules/BuyGiftCards';
import { CustomNextPage } from '../lib/types';
import {
  buyGiftCardPageQuery,
  buyGiftCardPageQueryVariables
} from '../core-types';
import { getQueryString } from '../lib/utils';
import { bootstrap } from '../lib/bootstrap';
import { useQuery } from '@apollo/client';
import { BUY_GIFT_CARD_PAGE_QUERY } from '../modules/BuyGiftCards/graphql';
import { useSanityTermsOfPurchase } from '../lib/sanity/useSanityTermsOfPurchase';

const BuyGiftCardPage: CustomNextPage<{
  statusCode?: number;
  variables: buyGiftCardPageQueryVariables;
}> = props => {
  const { variables, url, systemConfig, statusCode } = props;
  const { loading, data } = useQuery<
    buyGiftCardPageQuery,
    buyGiftCardPageQueryVariables
  >(BUY_GIFT_CARD_PAGE_QUERY, { variables });

  // preload terms of purchase, used for terms checkbox
  useSanityTermsOfPurchase();

  const buyGiftCardPage = data?.buyGiftCardPage;

  if (!loading && !buyGiftCardPage) {
    const err = new Error('Buy gift card page not found');
    err.code = 'ENOENT';
    throw err;
  }

  const title = buyGiftCardPage?.title;

  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      render={() => {
        if (!data || !buyGiftCardPage) {
          return null;
        }

        return (
          <BuyGiftCards
            data={data}
            buyGiftCardPage={buyGiftCardPage}
            systemConfig={systemConfig}
          />
        );
      }}
    />
  );
};

BuyGiftCardPage.getInitialProps = async ctx => {
  const productSlug = getQueryString(ctx.query.productSlug);
  const variables = {
    productSlug: productSlug || '',
    fetchProduct: !!productSlug
  };
  const buyGiftCardPageResult = await ctx.apolloClient.query<
    buyGiftCardPageQuery,
    buyGiftCardPageQueryVariables
  >({
    query: BUY_GIFT_CARD_PAGE_QUERY,
    variables
  });
  let statusCode;
  if (!buyGiftCardPageResult.data?.buyGiftCardPage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode,
    variables
  };
};

export default bootstrap(BuyGiftCardPage);
